package com.wintermar.inspection

import app.cash.sqldelight.ExecutableQuery
import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.SqlDriver
import kotlin.String

public class SqliteVersionQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun select_sqlite_version(): ExecutableQuery<String> = Query(878_756_210, driver, "SqliteVersion.sq", "select_sqlite_version", "SELECT sqlite_version()") { cursor ->
    cursor.getString(0)!!
  }
}
